import classNames from 'classnames'
import type { ReactNode } from 'react'
import Icon from '../icon'

export const Checkbox = ({
  checkStatus,
  handleChange = () => {},
  text = '',
  textPosition = 'right',
  className = '',
  disabled = false,
}: {
  checkStatus: boolean
  disabled?: boolean
  handleChange: (status: boolean) => void
  text?: ReactNode
  textPosition?: 'left' | 'right'
  className?: string
}) => {
  return (
    <label
      className={`
      w-fit cursor-pointer rounded text-black
      ${disabled ? 'cursor-not-allowed' : ''}
      ${className}
      `}
    >
      <span
        className={`flex items-center gap-4 ${disabled ? 'opacity-50' : ''}`}
      >
        <span
          className={classNames('block flex-1', {
            'order-first': textPosition === 'left',
            'order-last': textPosition === 'right',
          })}
        >
          {text}
        </span>

        <span aria-hidden="true">
          <Icon
            id={checkStatus ? 'checkbox-active' : 'checkbox-inactive'}
            width={20}
            height={20}
          />
        </span>
      </span>

      <input
        type="checkbox"
        className="sr-only"
        checked={checkStatus}
        onChange={(e) => {
          handleChange(e.target.checked)
        }}
        disabled={disabled}
      />
    </label>
  )
}
